/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import styles from './RMDAccountsNew.module.scss';

import React, { useState, useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import businessFlagIcon from '../../../assets/images/alert.svg';
import RMDTableNew from '../RMDTableNew/RMDTableNew';
import RMDTableMobile from '../RMDTableMobile/RMDTableMobile';
import Title from '../Title/Title';
import { getRMDSummary } from '../../../redux/modules/RMD/RMDSetting.selectors';
import { lastBusinessDateNumeric } from '../../../utils/dashboard-utils';
import { getBalanceAsOfDate } from '../../../redux/modules/UserFunds/userFunds.selectors';
import toolTip from "../../../assets/images/Tooltip.svg";
import {
  AS_OF_ACCOUNT_BALANCES,
  openModal as openModalAction
} from "../../../redux/modules/modals/modals.module";

const RMDAccountsNew = () => {
  const rmdSummary = useSelector(getRMDSummary);
  const balanceAsOfDate = useSelector(getBalanceAsOfDate);
  const { preRMDEligible } = rmdSummary;
  const dispatch = useDispatch();
  const [layoutType, setLayoutType] = useState('web');
  function changeMq() {
    setLayoutType(mq.matches ? 'mobile' : 'web');
  }

  let mq = window.matchMedia('screen and (max-width: 768px)');
  mq.addListener(changeMq);

  /* eslint-disable */
  useEffect(() => {
    changeMq();
  }, []);
  /* eslint-enable */

  return (
    <div
      id="RMD-Accounts"
      className={`${styles['module']} ${styles['RMD-Accounts']}`}
    >
      {preRMDEligible && (
        <div className={`${styles['pre-rmd-banner-container']}`}>
          <img
            alt="business-flag"
            src={businessFlagIcon}
            className={`${styles['business-flag-icon']}`}
            width="65"
            height="65"
          />
          <div className={`${styles['text']}`}>
            <h3 className={`${styles['title']}`}>
              You are currently not required to take an RMD from these accounts.
            </h3>
          </div>
        </div>
      )}
      <h2 className={`${styles['header']}`}>Your IRAs</h2>
      {preRMDEligible && (
        <div className={`${styles['sub-title']}`}>
          As of {lastBusinessDateNumeric(balanceAsOfDate)} unless otherwise indicated
          <button
          onClick={(e) => dispatch(openModalAction(AS_OF_ACCOUNT_BALANCES, {
            type: 'All'
          }))}
          className={`${styles['button-modal']}`}
          >
            <img
              className={styles['disable-img']}
              src={toolTip}
              alt="tool tip icon"
            />
          </button>
        </div>
      )}
      {!preRMDEligible &&
        <span className={`${styles['sub-title']}`}>As of {lastBusinessDateNumeric(balanceAsOfDate)}</span>
      }
      {layoutType === 'web' ? <RMDTableNew /> : <RMDTableMobile />}
    </div>
  );
};

export default RMDAccountsNew;
